import React from 'react'
import styled from 'styled-components'
import {Modal, ModalTitle} from '../Modal'
import {Button} from '../../elements/Button'
import './ElectionSelectionConfirmModal.scss'

export type ConstituencyChangeType = 'municipality' | 'county' | 'countyMunicipality'
export type ElectionChangeType = 'electionCounty' | 'electionMunicipality' | 'bothElections' | 'election'
export type ElectionModalType = ConstituencyChangeType | ElectionChangeType | undefined

interface Props {
  open: boolean
  type: ElectionModalType
  onClose: () => void
  onConfirm: () => void
}

const modalTexts = {
  municipality: {
    title: 'Olet vaihtamassa kotikuntaasi.',
    text: 'Jos vaihdat kotikuntasi, kaikki aikaisemmat kuntakohtaiset vastauksesi poistuvat.'
  },
  county: {
    title: 'Olet vaihtamassa hyvinvointialuettasi.',
    text: 'Jos vaihdat hyvinvointialueesi, kaikki aikaisemmat hyvinvointialuekohtaiset vastauksesi poistuvat.'
  },
  election: {
    title: 'Olet vaihtamassa vaalia.',
    text: 'Jos vaihdat vaalia, kaikki aikaisemmat vaalikohtaiset vastauksesi poistuvat.'
  },
  countyMunicipality: {
    title: 'Olet vaihtamassa kotikuntaasi ja hyvinvointialuetta.',
    text: 'Jos vaihdat kotikuntasi ja hyvinvointialueesi, kaikki aikaisemmat kunta- ja hyvinvointialuekohtaiset vastauksesi poistuvat.'
  },
  electionMunicipality: {
    title: 'Olet poistamassa ehdokkuuttasi kuntavaaleista.',
    text: 'Jos vaihdat vaalia, kaikki aikaisemmat kuntavaalikohtaiset vastauksesi poistuvat.'
  },
  electionCounty: {
    title: 'Olet poistamassa ehdokkuuttasi aluevaaleista.',
    text: 'Jos vaihdat vaalia, kaikki aikaisemmat aluevaalikohtaiset vastauksesi poistuvat.'
  },
  bothElections: {
    title: 'Olet tekemässä muutosta ollaksesi ehdolla molemmissa vaaleissa.',
    text:
      'Pääset vastaamaan molempien vaalien kysymyksiin tallentamalla ja aloittamalla vaalikoneen uudelleen. Aikaisemmat vastauksesi säilyvät.'
  }
} as const

const ElectionSelectionConfirmModal: React.FC<Props> = ({type, open, onClose, onConfirm}) => {
  return (
    <CustomModal isOpen={open} title={type ? modalTexts[type].title : ''}>
      <div className="election-selection-confirm-modal__text">{type && modalTexts[type].text}</div>
      <div className="election-selection-confirm-modal__buttons">
        <Button onClick={onClose} color="white">
          Peruuta
        </Button>
        <Button onClick={onConfirm}>Jatka</Button>
      </div>
    </CustomModal>
  )
}

export default ElectionSelectionConfirmModal

const CustomModal = styled(Modal)`
  ${ModalTitle} {
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 0;
  }
`
